import React, { Fragment } from 'react';
import { LightBlueButton, TextButtonLight } from '../../components';
import * as Images from '../../assets';
import { ArrowRightAlt } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import { routesName } from '../../constants/routes-name';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';

const Header = ({ page = '' }) => {
  const { user } = useSelector(({ user }) => user);
  const location = useLocation();

  return (
    <div className="raletive mt-[-70px]">
      <div
        //className="pt-[70px]"
        style={{
          backgroundImage: `url('${Images.homePage4}')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          backgroundAttachment: 'fixed',
          transition:
            'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s',
        }}
      >
        <div
          className="h-full w-full lg:py-24 md:py-16 py-12 lg:px-12 md:px-8 px-6"
          style={{
            backgroundColor: page === 'transparent',
            backgroundImage:
              'radial-gradient(at center center, #1b2e4899 23%, black 100%)',
            //opacity: '0.86',
            transition: 'background 0.3s, border-radius 0.3s, opacity 0.3s',
          }}
        >
          <Grid container className="flex justify-center">
            <Grid item lg={7} md={8} sm={10} xs={12}>
              <div className="mt-[30px] py-[20px] h-full w-full flex justify-center flex-col items-center gap-6 ">
                {page === 'home' ? (
                  <Fragment>
                    <div className="mt-[70px] text-[var(--blue)] text-sm font-bold text-center tracking-[3px] uppercase leading-normal">
                      Welcome to Aid-LINK <br />
                      We believe in transparency and opportunity
                    </div>
                    <div className="divider-light" />
                    <div>
                      <div className="text-white lg:text-6xl md:text-4xl text-2xl font-bold text-center leading-normal">
                        The best tender alert service in the Humanitarian Sector
                      </div>
                      <div className="text-white lg:text-3xl md:text-2xl text-xl text-center">
                        The solution for all your sales leads...
                      </div>
                    </div>
                    <div className="text-white text-md text-center">
                      Explore the world of undiscovered business opportunities
                      available in the humanitarian sector for your company with{' '}
                      <br />
                      <span className="text-white">
                        <a
                          className="text-white border-b border-b-[var(--blue)]"
                          //href="https://aid-link.com"
                        >
                          <strong>aid-link.com</strong>
                        </a>
                      </span>
                    </div>
                    <div className="flex gap-5 mt-6">
                      {!user && (
                        <Link to={routesName.pricing}>
                          <LightBlueButton
                            size="large"
                            sx={{ fontSize: '12px' }}
                          >
                            Join Aid-LINK
                          </LightBlueButton>
                        </Link>
                      )}
                      {!user && (
                        <Link to={routesName.login}>
                          <TextButtonLight
                            size="large"
                            sx={{ fontSize: '12px' }}
                          >
                            Login <ArrowRightAlt fontSize="small" />
                          </TextButtonLight>
                        </Link>
                      )}
                      {user && (
                        <Link to={routesName.dashboard}>
                          <LightBlueButton
                            size="large"
                            sx={{ fontSize: '12px' }}
                          >
                            Go to dashboard
                          </LightBlueButton>
                        </Link>
                      )}
                    </div>
                    <div>
                      <div className="h-28 mt-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 1920 1080"
                          //width="1920"
                          // height="1080"
                          preserveAspectRatio="xMidYMid meet"
                          style={{
                            width: '200px',
                            height: '200px',
                            transform: 'transform: translate3d(0px, 0px, 0px)',
                          }}
                        >
                          {/*  <defs>
                            <clipPath id="__lottie_element_2">
                              <rect
                                width="1920"
                                height="1080"
                                x="0"
                                y="0"
                              ></rect>
                            </clipPath>
                          </defs> */}
                          <g clipPath="url(#__lottie_element_2)">
                            <g
                              transform="matrix(1,0,0,1,996,520)"
                              opacity="1"
                              style={{ display: 'block' }}
                            >
                              <g
                                opacity="1"
                                transform="matrix(1,0,0,1,-49.992000579833984,25.312000274658203)"
                              >
                                <path
                                  strokeLinecap="butt"
                                  strokeLinejoin="miter"
                                  fillOpacity="0"
                                  strokeMiterlimit="4"
                                  stroke="rgb(248,242,242)"
                                  strokeOpacity="1"
                                  strokeWidth="20"
                                  d=" M106.00800323486328,-127.30449676513672 C106.00800323486328,-127.30449676513672 106.00800323486328,127.30449676513672 106.00800323486328,127.30449676513672 C106.00800323486328,185.81031799316406 58.50581741333008,233.3125 0,233.3125 C0,233.3125 0,233.3125 0,233.3125 C-58.50581741333008,233.3125 -106.00800323486328,185.81031799316406 -106.00800323486328,127.30449676513672 C-106.00800323486328,127.30449676513672 -106.00800323486328,-127.30449676513672 -106.00800323486328,-127.30449676513672 C-106.00800323486328,-185.81031799316406 -58.50581741333008,-233.3125 0,-233.3125 C0,-233.3125 0,-233.3125 0,-233.3125 C58.50581741333008,-233.3125 106.00800323486328,-185.81031799316406 106.00800323486328,-127.30449676513672z"
                                ></path>
                              </g>
                            </g>
                            <g
                              transform="matrix(1,0,0,1,956,479.9931335449219)"
                              opacity="0.4000625000000003"
                              style={{ display: 'block' }}
                            >
                              <g
                                opacity="1"
                                transform="matrix(1,0,0,1,-11.440999984741211,-29.128999710083008)"
                              >
                                <path
                                  className="animate-pulse"
                                  fill="rgb(255,255,255)"
                                  fillOpacity="1"
                                  d=" M0,-24.42449951171875 C13.277886390686035,-24.42449951171875 24.058500289916992,-13.479881286621094 24.058500289916992,0 C24.058500289916992,13.479881286621094 13.277886390686035,24.42449951171875 0,24.42449951171875 C-13.277886390686035,24.42449951171875 -24.058500289916992,13.479881286621094 -24.058500289916992,0 C-24.058500289916992,-13.479881286621094 -13.277886390686035,-24.42449951171875 0,-24.42449951171875z"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </Fragment>
                ) : page === 'join' ? (
                  <Fragment>
                    <div className="text-white lg:text-6xl md:text-4xl text-2xl font-bold text-center">
                      Choose your plan
                    </div>

                    <div className="text-white text-md text-center">
                      All our plans always include: ✓ Full access to all live
                      and open tenders ✓ Daily e-mail notifications send to your
                      inbox ✓ Search tool provides quick overview of all tenders
                      ✓ Personal dashboard with business preferences ✓ Unlimited
                      free e-mail support in the entire license period ✓ 7 Day
                      FREE trial <br />
                    </div>
                  </Fragment>
                ) : page === 'about' ? (
                  <Fragment>
                    <div className="text-white lg:text-6xl md:text-4xl text-2xl font-bold text-center">
                      About
                    </div>
                  </Fragment>
                ) : page === 'tenders' ? (
                  <Fragment>
                    <div className="text-white lg:text-6xl md:text-4xl text-2xl font-bold text-center">
                      Tenders
                    </div>
                    <div className="flex flex-wrap ">
                      <Link
                        to={routesName.tenders}
                        className={`border-r border-r-[var(--blue)] text-sm capitalize px-3 ${
                          location.pathname === routesName.tenders
                            ? 'text-white'
                            : 'text-[var(--blue)]'
                        }`}
                      >
                        <span className="uppercase tracking-[2px] font-semibold">
                          All Tenders
                        </span>
                      </Link>
                      <Link
                        to={routesName.my_tenders}
                        className={`border-r border-r-[var(--blue)] text-sm capitalize px-3 ${
                          location.pathname === routesName.my_tenders
                            ? 'text-white'
                            : 'text-[var(--blue)]'
                        }`}
                      >
                        <span className="uppercase tracking-[2px] font-semibold">
                          My Tenders
                        </span>
                      </Link>

                      <Link className="text-[var(--blue)] text-sm capitalize px-3">
                        <span className="uppercase tracking-[2px] font-semibold">
                          Tender Alert Setting
                        </span>
                      </Link>
                    </div>
                  </Fragment>
                ) : page === 'contact' ? (
                  <Fragment>
                    <div className="text-white lg:text-6xl md:text-4xl text-2xl font-bold text-center">
                      Contact
                    </div>
                  </Fragment>
                ) : page === 'ngoun-staff' ? (
                  <Fragment>
                    <div className="text-white lg:text-6xl md:text-4xl text-2xl font-bold text-center">
                      PUBLISH TENDER (UN/NGO)
                    </div>
                  </Fragment>
                ) : page === 'terms&conditions' ? (
                  <Fragment>
                    <div className="text-white text-6xl font-bold text-center">
                      Terms & Conditions
                    </div>
                  </Fragment>
                ) : (
                  <Fragment>
                    <div className="text-white lg:text-6xl md:text-4xl text-2xl font-bold text-center">
                      {page === 'forgot-password'
                        ? 'Forgot Password'
                        : page === 'login'
                        ? 'Login'
                        : page === 'sign-up'
                        ? 'Sign Up'
                        : page === 'dashboard'
                        ? 'Dashboard'
                        : page === 'draftBids'
                        ? 'Draft Bids'
                        : page === 'submittedBids'
                        ? 'Submitted Bids'
                        : page === 'chats'
                        ? 'Messages'
                        : page === 'reset-password'
                        ? 'Create New Password'
                        : page === 'openChat'
                        ? 'Message'
                        : page === 'allTender'
                        ? 'All Tenders'
                        : page === 'myTender'
                        ? 'My Tenders'
                        : page === 'unApprovedTenders'
                        ? 'Unapproved Tenders'
                        : page === 'viewTender'
                        ? 'Tender Detail'
                        : page === 'bidTender'
                        ? 'Bid To Tender'
                        : page === 'editUnApprovedTendersPath'
                        ? 'Edit Unapproved Tender'
                        : ''}
                    </div>
                  </Fragment>
                )}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default Header;
